import { InviteTeamMemberSection } from "@faire/deprecated-retailer-visitor-shared/views/multi-user/Invite/InviteTeamMemberSection";
import { PageName } from "@faire/deprecated-retailer-visitor-shared/views/multi-user/Share/consts";
import { trackRetailerTeamSharingInviteUserLeanFlowClick } from "@faire/web-api--source/events/retailerTeamSharing/click/inviteUserLeanFlow";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Modal } from "@faire/web/slate/Modal";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps {
  onInvite: () => void;
  onBack: () => void;
  onClose: () => void;
  pageName: PageName;
}

export const LeanInviteTeamModal: React.FC<IProps> = ({
  onInvite,
  onBack,
  onClose,
  pageName,
}) => {
  const viewport = useViewport();
  const { strictLocalize } = useStrictLocalization();

  const getModalDescriptionFromPage = (pageName: PageName) => {
    switch (pageName) {
      case PageName.ORDER:
        return strictLocalize({
          id: "RF/+6V",
          defaultMessage:
            "Team members can help you track orders and can be automatically kept in the loop on order updates.",
          description: {
            text: "Description for modal to let user know they can invite team members to manage orders",
            img: "https://cdn.faire.com/fastly/d07eafe88d9614893de29df287f19fe08660db830ac5fbf5b2eb2446d2025329.png",
          },
        });
      case PageName.INVOICE:
        return strictLocalize({
          id: "1BuvmQ",
          defaultMessage:
            "Team members can access invoices to help with tracking or payments.",
          description: {
            text: "Description for modal to let user know they can invite team members to manage invoices",
            img: "https://cdn.faire.com/fastly/959ee1017b4a9aaaa8ff559c4a02b9de70e89c270d8113eb9d0af538f67d33d0.png",
          },
        });
      case PageName.BRAND:
        return strictLocalize({
          id: "Qt9Mta",
          defaultMessage: "Team members can view full brand details.",
          description: {
            text: "Description of the invite modal",
            img: "https://cdn.faire.com/fastly/74748d3e47bfd8c737935da8c14c2819c9d4ae14d3c856b71bc1e7e9dcb9c91b.png",
          },
        });
      case PageName.PDP:
      default:
        return strictLocalize({
          id: "7XF5Yr",
          defaultMessage: "Team members can view full product details.",
          description: {
            text: "Description of the invite modal",
            img: "https://cdn.faire.com/fastly/bd9219d99c33185051191c966ed979967d3b830e2d89a94324a90c02958a223f.png",
          },
        });
    }
  };

  return (
    <Modal
      padding="88px 24px 24px 24px"
      width={viewport.isTabletAndAbove ? "420px" : undefined}
      onClose={onClose}
      onBack={onBack}
      align="stretch"
      data-test-id="lean-invite-team-modal"
    >
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          id="o0umuH"
          defaultMessage="Invite a team member"
          description={{
            text: "Title of the invite modal",
            img: "https://cdn.faire.com/fastly/bd9219d99c33185051191c966ed979967d3b830e2d89a94324a90c02958a223f.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Typography>{getModalDescriptionFromPage(pageName)}</Typography>
      <Spacer height="2x" />
      <InviteTeamMemberSection
        onInviteSent={onInvite}
        onInviteButtonClick={() =>
          trackRetailerTeamSharingInviteUserLeanFlowClick(pageName)
        }
      />
    </Modal>
  );
};
